import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CalculatorBrandParamDTO,
  CalculatorModelParamDTO,
  CalculatorTypeVehicleParamDTO,
  CalculatorVersionParamDTO,
  CommonDataDTO,
  TypeVehicleReturnDTO,
  VehicleTypeFuel,
  VersionAutoDTO,
} from '@app/requests/model/combos-model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequestDataAutosService {
  constructor(private _http: HttpClient) {}

  getTypeVehicle(callTypeVehicle: CalculatorTypeVehicleParamDTO): Observable<TypeVehicleReturnDTO[]> {
    return this._http.post<TypeVehicleReturnDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlTypeVehicle,
      callTypeVehicle
    );
  }

  getBrand(callBrand: CalculatorBrandParamDTO): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_REQUEST + environment.subUrlBrandByYear, callBrand);
  }

  getModel(callModel: CalculatorModelParamDTO): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlModelByBrandAndYear,
      callModel
    );
  }

  getVersion(callVersion: CalculatorVersionParamDTO): Observable<VersionAutoDTO[]> {
    return this._http.post<VersionAutoDTO[]>(environment.URL_BASE_REQUEST + environment.subURLVersion, callVersion);
  }

  getFuelType(request: VehicleTypeFuel): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_REQUEST + environment.subURLFuelType, request);
  }
}
